import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { OverviewResumeState } from '@services/state/overview-resume-state/overview-resume.state';
import { FormatListPipe } from '@pages/dashboard/portfolio/general-overview/components/warning-overview/format-list/format-list.pipe';

@Component({
  selector: 'warning-overview',
  standalone: true,
  imports: [NgIcon, FormatListPipe],
  template: `
    @let operationsPending = indicators()?.pending_update_operations;
    @if(operationsPending && operationsPending.length > 0){
      <div class="container">
        <ng-icon [name]="'phosphorWarningCircle'"/>
        <p>
          Currently, only up to date facility data is displayed. The information for
          {{ operationsPending | formatList }}
          remains outdated.
        </p>
      </div>
    }
  `,
  styles: `
    .container{
      background-color:#EFF6FFF2;
      color: #2563EB;
      border: solid #BFDBFE 1px;
      border-radius: 6px;
      padding: 7px 12px;
      display: flex;
      align-items: center;
      gap: 6px;
      box-shadow: 0px 4px 8px 0px #02050A0A;
      margin-bottom:33px;
      ng-icon {
       flex-shrink: 0;
      }
      p{
        color: #2563EB;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarningOverview {
  public indicators = inject(OverviewResumeState).coreMetrics;
}
